import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Alert from '~/Common-Objects/UI/Alert'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import WarningHolder from '~/Common-Objects/UI/Cards/WarningHolder'
import axios from '~/data/http/axios'
import DragDropFunctions from '~/utils/TemplateEditor/dragDropFunctions'

export default function MergeTagWarnings({ id, formLandingPage = '', isFormLandingPage = false, templateJson = {} }) {
    const account = useSelector((state) => state.accountMaster)
    const [results, setResults] = useState(null)

    useEffect(() => {
        if (id) {
            init()
        }
    }, [id])

    const init = async () => {
        const html = DragDropFunctions.generateHtmlFromJson(templateJson, false, templateJson.globalVariables)
        if (account?.accountMaster?.options?.unsubscribeTemplateId == id) formLandingPage = 'unsubscribe'
        if (account?.accountMaster?.options?.updateTemplateId == id) formLandingPage = 'update'
        const result = (
            await axios.post('/template/mergeTagsTest?returnAll=true', {
                bodyHtml: html,
                type: formLandingPage
            })
        ).data

        setResults(result)
    }

    if (!results) return <LoadingIcons />

    return (
        <div style={{ position: 'relative' }}>
            {!results?.mergeTags?.length && (
                <Alert
                    className='text-center'
                    header='No Merge Tags found'
                    content="We didn't find any merge tags in your template."
                    type='info'
                    hideIcon={true}
                />
            )}

            {results.mergeTags.map((row, index) => {
                let classes = 'dndEditorv2-linkChecker '
                let error = ''
                let errorIcon = ''
                let errorColor = ''
                if (row.status === 0) {
                    classes += ' dndEditorv2-linkChecker-error'
                    error = 'Invalid Merge Tag'
                    errorIcon = 'alert'
                    errorColor = 'var(--yellow-500)'
                }
                if (row.status === 1) {
                    error = 'Valid Merge Tag'
                    errorIcon = 'tickCircle'
                    errorColor = 'var(--cyan-500)'
                }
                return (
                    <div key={index} className={classes}>
                        <div className='dndEditorv2-linkCheckerText'>
                            <div className='dndEditorv2-linkCheckerTitle'>{row.description}</div>
                            <div className='dndEditorv2-linkCheckerUrl'>{row.value}</div>
                        </div>
                        <div className='dndEditorv2-linkCheckerError'>
                            {errorIcon && (
                                <Icons
                                    data-tooltip-content={error}
                                    data-tooltip-id={`mergeTagChecker-error-${index}`}
                                    data-tooltip-style={{ maxWidth: '200px', zIndex: 99999 }}
                                    data-tooltip-position='top'
                                    icon={errorIcon}
                                    color={errorColor}
                                    alt={error}
                                    title={error}
                                    style={{ width: 16, height: 16 }}
                                />
                            )}
                        </div>
                    </div>
                )
            })}
            {!results.success && (
                <>
                    {!!results.error && <div className='mar-b10'>There is a problem near: </div>}
                    {!!results.error && <WarningHolder className='mar-b20'>{results.error}</WarningHolder>}
                    <div className='mar-b10'>The template will not be saved until resolved</div>
                </>
            )}
        </div>
    )
}
